import { useRouterState } from '@tanstack/react-router'
import { AiChatPanelLayout } from './ai-chat-panel-layout'
import { canOpenAiChat } from './ai-chat-live-drawer'
import type { ReactNode } from 'react'
import { useCurrentUserProfile } from '@/entities/user/model/use-current-user-profile'

export function WorkspaceAiChatLayout({
  children,
  header,
  navigationPinned,
}: {
  children: ReactNode
  header: ReactNode
  navigationPinned: boolean
}) {
  const { currentUser } = useCurrentUserProfile()
  const pathname = useRouterState({
    select: (state) => state.location.pathname,
  })

  return (
    <AiChatPanelLayout
      enabled={canOpenAiChat(currentUser)}
      userId={currentUser?.id}
      workspaceId={currentUser?.workspaceId ?? undefined}
      scope="workspace"
      pathname={pathname}
      header={header}
      navigationPinned={navigationPinned}
    >
      {children}
    </AiChatPanelLayout>
  )
}
